import { api, type User } from '../lib/api.js';
import { clear, el, fmt } from '../lib/dom.js';

export async function renderListe(root: HTMLElement, user: User): Promise<void> {
  clear(root);
  document.body.classList.remove('hat-navbar');

  const topbar = el('header', { class: 'topbar' });
  const brand = el('div', { class: 'brand' }, 'Wertermittlung bei Pächterwechsel');
  brand.append(el('small', {}, `Angemeldet: ${user.name}`));
  const logout = el('button', { class: 'linkbtn', type: 'button' }, 'Abmelden');
  logout.addEventListener('click', () => {
    void api.logout().finally(() => {
      location.hash = '#/login';
    });
  });
  topbar.append(brand, logout);

  const main = el('main');
  const head = el('div', { class: 'step-head' });
  head.append(
    el('div', { class: 'eyebrow' }, 'Protokolle'),
    el('h2', {}, 'Wertermittlungen'),
    el(
      'p',
      {},
      user.rolle === 'verband'
        ? 'Verbandsansicht: Protokolle aller Vereine.'
        : 'Alle Protokolle Ihres Vereins. Entwürfe können jederzeit fortgesetzt werden.',
    ),
  );
  main.append(head);

  if (user.rolle !== 'verband') {
    const neu = el(
      'button',
      { class: 'btn btn-add', type: 'button' },
      '+ Neues Protokoll beginnen',
    );
    neu.addEventListener('click', () => {
      neu.disabled = true;
      void api
        .protokollNeu()
        .then(({ id }) => {
          location.hash = `#/p/${id}`;
        })
        .finally(() => {
          neu.disabled = false;
        });
    });
    main.append(neu, el('div', { style: 'height:14px' }));
  }

  const liste = el('ul', { class: 'protoliste' });
  main.append(liste);
  root.append(topbar, main);

  const { protokolle } = await api.protokollListe();
  if (protokolle.length === 0) {
    liste.append(el('div', { class: 'list-empty' }, 'Noch keine Protokolle vorhanden.'));
    return;
  }
  for (const p of protokolle) {
    const li = el('li');
    const btn = el('button', { class: 'protoitem', type: 'button' });
    const left = el('div');
    const titel = [p.anlage, p.parzelle && `Parzelle ${p.parzelle}`].filter(Boolean).join(' · ');
    left.append(
      el('div', {}, titel || 'Ohne Bezeichnung'),
      el(
        'div',
        { class: 'meta' },
        `${p.paechter || 'Pächter/in offen'} · ${new Date(p.updatedAt).toLocaleDateString('de-DE')}`,
      ),
    );
    const right = el('div', { style: 'text-align:right;display:grid;gap:4px;justify-items:end' });
    right.append(
      el(
        'span',
        { class: 'statuschip' + (p.status === 'abgeschlossen' ? ' final' : '') },
        p.status === 'abgeschlossen' ? 'Abgeschlossen' : 'Entwurf',
      ),
      el('span', { class: 'summe' }, fmt(p.summe)),
    );
    btn.append(left, right);
    btn.addEventListener('click', () => {
      location.hash = `#/p/${p.id}`;
    });
    li.append(btn);
    liste.append(li);
  }
}
